import { render, staticRenderFns } from "./Crisis_addmulti_talk.vue?vue&type=template&id=045fd7fe"
import script from "./Crisis_addmulti_talk.vue?vue&type=script&lang=js"
export * from "./Crisis_addmulti_talk.vue?vue&type=script&lang=js"
import style0 from "./Crisis_addmulti_talk.vue?vue&type=style&index=0&id=045fd7fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports